/* eslint-disable react/jsx-no-literals */
/* eslint-disable no-tabs */
import { FC } from 'react';

import { MpOl } from 'shared/ui/MpOl';
import { MpPropertyTitle } from 'shared/ui/MpPropertyTitle';
import { MpText } from 'shared/ui/MpText';
import { ImageStyled } from './OTVBInstructions.styles';

export type ApplicationInstructionProps = {
	applicationId: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const OTVBInstructions: FC<ApplicationInstructionProps> = () => (
	<>
		<MpPropertyTitle>Подключение</MpPropertyTitle>
		<MpOl style={{ gap: `12px` }}>
			<li>
				<MpText style={{ marginBottom: `32px` }}>
					Нажмите кнопку «Подключить». Откроется окно ввода кода для&nbsp;подключения.
				</MpText>
				<ImageStyled
					style={{ width: `560px` }}
					src='https://cdn.dodostatic.net/static/marketplace/otvb/instruction-1-new'
				/>
			</li>
			<li>
				<MpText style={{ marginBottom: `32px` }}>
					Откройте ТВ-Борды через&nbsp;браузер телевизора или&nbsp;компьютера по&nbsp;ссылке vdo.do/otvb.
					На&nbsp;экране отобразится код&nbsp;— введите его&nbsp;в&nbsp;окно на&nbsp;странице маркетплейса.
				</MpText>
				<ImageStyled
					src='https://cdn.dodostatic.net/static/marketplace/otvb/instruction-2-new'
					style={{ width: `530px`, paddingLeft: `26px` }}
				/>
			</li>
			<li>
				<MpText>Выдайте доступ к&nbsp;вашим данным, нажав кнопку «Дать доступ».</MpText>
			</li>
			<li>
				<MpText>
					Через 10 секунд на&nbsp;вашем устройстве отобразится экран с&nbsp;метриками и&nbsp;отзывами.
					Если&nbsp;этого не&nbsp;произошло, повторите подключение еще&nbsp;раз.
				</MpText>
			</li>
			<li>
				<MpText>Чтобы подключить еще одно устройство, нажмите кнопку «Подключить еще»</MpText>
			</li>
		</MpOl>
		<MpPropertyTitle>Настройка борда</MpPropertyTitle>
		<MpOl style={{ gap: `12px` }}>
			<li>
				<MpText>После&nbsp;подключения нажмите кнопку «Настроить ТВ-Борд».</MpText>
			</li>
			<li>
				<MpText>
					Войдите в учетную запись и выдайте доступ к&nbsp;вашим данным, нажав кнопку «Дать доступ».{` `}
				</MpText>
			</li>
			<li>
				<MpText>
					Настройте ТВ-Борд и&nbsp;нажмите кнопку «Сохранить изменения». Настройки будут применены
					к&nbsp;бордам через&nbsp;5&nbsp;минут. Чтобы&nbsp;применить настройки сразу, обновите страницу
					с&nbsp;метриками и&nbsp;отзывами.
				</MpText>
			</li>
		</MpOl>
	</>
);
